module.exports = __webpack_public_path__ + "static/favicon-0ca196fd5e4e5f70292e39e1772d0fb1.png";